import { styled, Typography, Link } from '@mui/material';

export const PostW = styled('div')<{
  isAutomatedPost?: boolean;
  isSlider?: boolean;
  hideAttachments?: boolean;
}>`
  display: flex;
  flex-wrap: wrap;
  min-width: 560px;
  min-height: ${({ isSlider, hideAttachments }) =>
    isSlider ? '300px' : hideAttachments ? '220px' : 'unset'};
  align-content: ${({ hideAttachments }) => (hideAttachments ? 'space-between' : 'unset')};
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  max-height: unset;
  padding: 16px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.7);
  margin-bottom: ${({ isSlider }) => (isSlider ? '0px' : '24px')};
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 1280px) and (min-width: 1024px) {
    min-width: 450px;
  }

  @media (max-width: 1023px) {
    margin-bottom: 16px;
    min-width: unset;
    width: 100%;
    padding: 16px 16px 16px 16px;
  }
`;

export const PostTitle = styled(Typography)`
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  color: ${({ theme }) => theme.palette.primary.p080};
  margin-bottom: 8px;
  overflow: hidden;
  white-space: break-spaces;
`;

export const StrongW = styled('strong')`
  cursor: pointer;
  font-weight: 900 !important;
  width: 100%;
`;

export const PostContentWrapper = styled('div')`
  width: 100%;
  display: flex;
  flex-wrap: no-wrap;
  flex-direction: column;
  margin-bottom: 8px;
`;

export const PostDescription = styled('div', {
  shouldForwardProp: (propname) => propname !== 'hasAttachments',
})<{ hasAttachments?: boolean; isPoll?: boolean }>(({ theme, isPoll }) => ({
  fontSize: isPoll ? '16px' : '12px',
  lineHeight: isPoll ? '24px' : '16px',
  color: theme.palette.primary.p080,
  maxHeight: isPoll ? 'fit-content' : '300px',

  '& p': {
    margin: isPoll ? '8px 0 16px 0' : '12px 0',

    '&:has(code)': {
      margin: '4px 0',
    },
  },

  '& a': {
    color: theme.palette.info.main,
  },

  '& h1, h2, h3, h4, h5': {
    marginTop: 0,
    fontSize: 'inherit',
  },
}));

export const LeftSide = styled('div')`
  width: 100%;
  @media (max-width: 1023px) {
    margin-right: 0px;
  }
`;

export const ActionsW = styled('div')`
  position: relative;
  top: -8px;
  width: min-content;
`;

export const IconW = styled('div')`
  position: absolute;
  top: -10px;
  left: 530px;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  z-index: 2;
  border: 1px solid #ffd752;
  border-radius: 50%;

  @media (max-width: 1023px) {
    position: absolute;
    top: -10px;
    right: 0px;
    width: 32px;
    height: 32px;
    display: flex;
    flex-direction: row;
    margin-bottom: 12px;
    column-gap: 8px;
    svg {
      width: 32px;
      height: 32px;
    }
  }
`;

export const Container = styled('div')`
  width: 100%;
  position: relative;
  border-radius: 8px;
  max-width: 556px;
  background-color: #fbfbfb;
`;

export const TagW = styled('div')`
  display: flex;
  align-items: center;
  margin-top: 4px;
`;

export const TagContainer = styled('div')`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
  margin-bottom: 8px;
`;

export const TagsCounter = styled(Typography)`
  background: #dfe1e6;
  color: ${({ theme }) => theme.palette.primary.p080};
  border-radius: 10px;
  margin-left: 6px;
  padding: 3px 6px;
  font-weight: 400;
  font-size: 12px;
`;

export const LinkW = styled(Link)`
  color: ${({ theme }) => theme.palette.info.main};
  cursor: pointer;
  text-decoration-color: ${({ theme }) => theme.palette.info.main};
`;
